// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1ktD5","footer":"ModalCreateQualiphyProcedure_footer__3r5J-","additionData":"ModalCreateQualiphyProcedure_additionData__Q0MLo"};